<div class="relative min-h-screen lg:flex">
    <app-sidebar />
    <main class="flex-1 bg-gray-200 dark:bg-gray-900 lg:h-screen md:ml-16 transition-colors">
        <div class='flex flex-col h-screen justify-between'>
            <app-header class="hidden md:block" />
            <ng-content></ng-content>
            <div class='mb-auto'></div>
        </div>
    </main>
</div>